import { Skeleton } from 'v5/design-system/Skeleton';
import { cn } from 'v5/platform/dom/cn';
import { useSkeletonFade } from '../skeletonFade';
import { COLUMN_PX } from 'v5/patterns/page-layout/splitGeometry';
import { ResourceAsideRowsSkeleton } from '../aside/ResourceAsideRowSkeleton';
import { ResourcePaneSkeleton } from '../pane/ResourcePaneSkeleton';

/**
 * The whole resource page before it is there, in its own layout: the pane, the tabs with a
 * grid of tiles, the side panel. It waits a moment and fades in, so a fast load shows nothing.
 */
export function ResourcePageSkeleton() {
  const fade = useSkeletonFade();
  return (
    <div className="tailwind-root contents">
      <div className="flex h-screen bg-bg-subtle">
        <div className="h-full w-[350px] shrink-0 overflow-hidden border-r border-fg-default/15 bg-bg-default">
          <ResourcePaneSkeleton />
        </div>
        <div
          aria-hidden
          className={cn(
            'flex min-h-0 min-w-0 flex-1 gap-3 py-3 pr-3',
            fade.className
          )}
          style={fade.style}
        >
          <div className="min-w-0 flex-1 space-y-4 overflow-hidden">
            <div className="flex gap-2 px-4">
              {Array.from({ length: 4 }, (_, index) => (
                <Skeleton key={index} className="h-9 w-24 bg-fg-default/10" />
              ))}
            </div>
            <div className="flex items-center justify-between px-4">
              <Skeleton className="h-6 w-28 bg-fg-default/10" />
              <Skeleton className="h-9 w-64 bg-fg-default/10" />
            </div>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(12rem,1fr))] gap-3 px-4">
              {Array.from({ length: 8 }, (_, index) => (
                <Skeleton
                  key={index}
                  className="aspect-square rounded-xl border border-border-default bg-bg-default"
                />
              ))}
            </div>
          </div>
          <div
            className="hidden min-[1300px]:block shrink-0 overflow-hidden rounded-xl border border-border-default bg-bg-default"
            style={{ width: COLUMN_PX }}
          >
            <div className="flex min-h-12 items-center border-b border-border-default px-4">
              <Skeleton className="h-4 w-24" />
            </div>
            <ResourceAsideRowsSkeleton lead="dot" rows={1} />
            <div className="border-t border-border-default">
              <div className="flex min-h-12 items-center px-4">
                <Skeleton className="h-4 w-28" />
              </div>
              <ResourceAsideRowsSkeleton lead="dot" trailing="text" />
            </div>
            <div className="border-t border-border-default">
              <div className="flex min-h-12 items-center px-4">
                <Skeleton className="h-4 w-28" />
              </div>
              <ResourceAsideRowsSkeleton lead="avatar" trailing="badge" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
